import { PgaPolicy } from "src/shared/models/pga-policy.model";

export abstract class Benefit {
    static hasAccess(policies: PgaPolicy[]): boolean {
        return false;
    }
}
